const tripActions = [
    { value: "complete", icon: "check" },
    { value: "cancel", icon: "crossInACircleFilled" },
    { value: "not_requested", icon: "questionInCircle" },
    { value: "unfulfilled", icon: "indexClose" },
    { value: "not_loaded", icon: "minusInCircleFilled" },
    { value: "absent", icon: "eyeClosed" },
    { value: "enhanceRoute", icon: "visMapRegion" },
];

export default tripActions;
